// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"756":"0b806fc2","983":"56617188"}[chunkId] + ".chunk.js";
};